<template>
<div>
  <b-row class="mt-5 mb-1">
      <b-col>
        <h2>
          <span class="dbb-red">Architects</span>
        </h2>
      </b-col>
    </b-row>

    <b-row class="my-4">
      <b-col sm="3" md="3" lg="3">
        <b-img rounded fluid src="@/assets/hanayik_taylor.png">
        </b-img>
      </b-col>
      <b-col sm="6">
        <h3>Taylor Hanayik</h3>
        <p>
          <b>Digital Brain Bank Implementation Lead</b>
          <br>
        </p>
        <p>
          <i>
            I am a research software engineer. I focus my efforts on creating user friendly neuroimaging software for research and clinical applications. My general research interests are in medical image segmentation and pathology detection.
          </i>
        </p>
      </b-col>
    </b-row>

    <b-row class="my-4">
      <b-col sm="3" md="3" lg="3">
        <b-img rounded fluid src="@/assets/howard_amy.png">
        </b-img>
      </b-col>
      <b-col sm="6">
        <h3>Amy Howard</h3>
        <p>
          <b>Digital Brain Bank Contributor</b>
          <br>
        </p>
        <p>
        <i>
        I am a postdoctoral researcher. I focus on different ways in which we can combine complementary data from microscopy and diffusion MRI to both validate and drive biophysical modelling of the brain tissue microstructure.
        </i>
        </p>
      </b-col>
    </b-row>

    <b-row class="my-4">
      <b-col sm="3" md="3" lg="3">
        <b-img rounded fluid src="@/assets/jbabdi_saad.png">
        </b-img>
      </b-col>
      <b-col sm="6">
        <h3>Saad Jbabdi</h3>
        <p>
          <b>Digital Brain Bank Analysis Lead</b>
          <br>
        </p>
        <p>
          <i>
          I am a Professor of Biomedical Engineering. I work at the interface of computational modelling, MRI physics and neuroscience. Broadly, my scientific goal is to achieve a better understanding of the structural and functional organisation of the brain at a systems level.
          </i>
        </p>
      </b-col>
    </b-row>

    <b-row class="my-4">
      <b-col sm="3" md="3" lg="3">
        <b-img rounded fluid src="@/assets/rogier_mars.png">
        </b-img>
      </b-col>
      <b-col sm="6">
        <h3>Rogier Mars</h3>
        <p>
          <b>Digital Brain Zoo Lead</b>
          <br>
        </p>
        <p>
          <i>
            I am an Associate Professor at WIN and head of the Neuroecology Lab. We compare brain organization across species to understand phylogenetic diversity in brain organization and to develop ways to improve the translation between preclinical and human research.
          </i>
        </p>
      </b-col>
    </b-row>

    <b-row class="my-4">
      <b-col sm="3" md="3" lg="3">
        <b-img rounded fluid src="@/assets/miller_karla.png">
        </b-img>
      </b-col>
      <b-col sm="6">
        <h3>Karla Miller</h3>
        <p>
          <b>Digital Brain Bank Principal Investigator</b>
          <br>
        </p>
        <p>
          <i>
            I am a Professor of Biomedical Engineering. I develop novel methods for acquiring, reconstructing and analyzing MRI scans of the brain. Much of my work focuses on relating MRI to microscopy, for which I collaborate with neuroscience colleagues in Oxford and elsewhere to study neuronal health and disease.
          </i>
        </p>
      </b-col>
    </b-row>

    <b-row class="my-4">
      <b-col sm="3" md="3" lg="3">
        <b-img rounded fluid src="@/assets/placeholder.gif">
        </b-img>
      </b-col>
      <b-col sm="6">
        <h3>Duncan Mortimer</h3>
        <p>
          <b>Digital Brain Bank System Administrator</b>
          <br>
        </p>
        <p>
          <i>
          I am a Senior Informatics Officer. I manage the IT facilities at WIN, including HPC cluster management, web server administration and systems management.
          </i>
        </p>
      </b-col>
    </b-row>


    <b-row class="my-4">
      <b-col sm="3" md="3" lg="3">
        <b-img rounded fluid src="@/assets/tendler_benjamin.jpg">
        </b-img>
      </b-col>
      <b-col sm="6">
        <h3>Benjamin Tendler</h3>
        <p>
          <b>Digital Brain Bank Project Lead</b>
          <br>
        </p>
        <p>
          <i>
            I am a postdoctoral fellow. I develop approaches to transform brain images into biologically meaningful measurements, providing us with an insight into the structure & composition of the brain. I have a particular interest in using these methods to identify processes in neurodegenerative disease. 
          </i>
        </p>
      </b-col>
    </b-row>

    <b-row class="mt-5 mb-1">
      <b-col>
        <h2>
          <span class="dbb-red">Contributors</span>
        </h2>
      </b-col>
    </b-row>
    <b-row class="mt-2 mb-1">
      <b-col>
        <h3>
          Digital Anatomist
        </h3>
      </b-col>
    </b-row>

    <b-row class="my-4">
      <b-col sm="6">
        <p>
          Olaf Ansorge, Sean Foxley, Jeroen Mollink, Menuka Pallebage-Gamarallage
        </p>
      </b-col>
    </b-row>
          
    <b-row class="my-4">
      <b-col sm="6">
        <p>
          Tissue samples provided by:<br>
Oxford Brain Bank
        </p>
      </b-col>
    </b-row>

    <b-row class="mt-2 mb-1">
      <b-col>
        <h3>
          Digital Brain Zoo
        </h3>
      </b-col>
    </b-row>

    <b-row class="my-4">
      <b-col sm="6">
        <p>
          Gregory S. Berns, Mads F. Bertelsen, Katherine L. Bryant, Sean Foxley, Martijn van den Heuvel, Alexandre A. Khrapitchev, Paul R. Manger, Lea Roumazeilles, Jerome Sallet, Lianne H. Scholtens
        </p>
      </b-col>
    </b-row>
          
    <b-row class="my-4">
      <b-col sm="6">
        <p>
          Tissue samples provided by:<br>
          Australian Museum<br>
          Copenhagen Zoo<br>
          Primate Brain Bank<br>
          Save the Tasmanian Devil<br>
          Smithsonian<br>
          Zoological Society of London
        </p>
      </b-col>
    </b-row>

    <b-row class="mt-2 mb-1">
      <b-col>
        <h3>
          Digital Pathologist
        </h3>
      </b-col>
    </b-row>

    <b-row class="my-4">
      <b-col sm="6">
        <p>
          Olaf Ansorge, Sarah Bangerter-Christensen, Sean Foxley, Istvan N. Huszar, Anna Leonte, Ricarda A.L. Menke, Jeroen Mollink, Menuka Pallebage-Gamarallage, Connor Scott, Adele Smart, Martin R. Turner, Chaoyue Wang
        </p>
      </b-col>
    </b-row>
          
    <b-row class="my-4">
      <b-col sm="6">
        <p>
          Tissue samples provided by:<br>
          Oxford Brain Bank
        </p>
      </b-col>
    </b-row>
 

</div>
  
</template>

<script>
export default {
  name: "contributors"
  
}
</script>

<style scoped>
.dbb-red {
  color: #8b2a34;
}
</style>
